function breakPromise() {
  return new Promise(() => {});
}

export default breakPromise;
